<template>
    <b-button variant="-ternary btn--outline btn--trash" size="-small" @click="handleDeleteProfile">
        <svg class="icon icon--trash">
            <use xlink:href="#trash"></use>
        </svg>
    </b-button>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'slicing-profile-delete-button',
        props: ['profileId', 'profileName', 'confirmMessage'],
        data() {
            return {
                dialogVisible: false
            }
        },
        methods: {
            ...mapActions(['deleteProfile']),

            handleDeleteProfile() {
                const deleteAction = () => {
                    this.deleteProfile(this.profileId).then(data => {
                        if (!data.result) {
                            this.msgBoxOk('Failed to delete slicing profile: ' + data.message);
                        }
                    })
                };
                if (this.confirmMessage) {
                    this.msgBoxConfirm(this.confirmMessage).then((val) => {
                        if (val) {
                            deleteAction();
                        }
                    })
                } else {
                  deleteAction();
                }
            }
        }
    }
</script>
